import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=47c23310&scoped=true&"
import script from "./GlobalFooter.vue?vue&type=script&lang=tsx&"
export * from "./GlobalFooter.vue?vue&type=script&lang=tsx&"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=47c23310&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c23310",
  null
  
)

export default component.exports